export const comments_3750245 = {"data":{"data":[],"links":{}}}